// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"710":"74018f2f72033675a4ff","782":"d39095b5d16a9f706ca4"}[chunkId] + ".chunk.js";
};